<template>
  <AutoComplete
    v-model="model"
    v-bind="{
      disabled,
      placeholder
    }"
    input-class="w-full"
    :class="{ 'pointer-events-none': readonly }"
    :input-id="id"
    :invalid="invalid"
    :suggestions="options"
    option-label="subTitle"
    @blur="emits('blur', $event)"
    @focus="emits('focus', $event)"
    @complete="search"
    @item-select="onItemSelect"
  />
</template>

<script setup lang="ts">
import { DadataBankSuggestion, InputEmits, InputProps, useDadataRepository } from '@/shared';
import AutoComplete, { AutoCompleteCompleteEvent, AutoCompleteItemSelectEvent } from 'primevue/autocomplete';
import { ref } from 'vue';

type BankOption = DadataBankSuggestion & {
  subTitle: string;
};

defineProps<InputProps>();

const emits = defineEmits<
  InputEmits & {
    itemSelect: [DadataBankSuggestion];
  }
>();

const model = defineModel<string | null>();
const options = ref<BankOption[]>([]);
const dadataRepository = useDadataRepository();

async function search(event: AutoCompleteCompleteEvent) {
  const list = await dadataRepository.getBank(event.query);

  options.value = list.map(item => {
    const bic = item.data?.bic || '';
    const bankName = item.data?.name?.payment || item.data?.name?.full || item.value || '';
    const subTitle = bic ? `${bankName} (${bic})` : bankName;

    return { ...item, subTitle };
  });
}

function onItemSelect(event: AutoCompleteItemSelectEvent) {
  const bank = event.value as DadataBankSuggestion;
  const bic = bank.data?.bic || '';

  model.value = bic || bank.value;
  emits('itemSelect', bank);
}
</script>
